import { Component, OnInit, NgZone } from '@angular/core';
import { Roles } from '../Users/_models/user';
import { UserService } from '../Users/user.service';
import { AuthenticationService } from '../shared/authentication/authentication.service';
import "../../assets/scripts/omniture.js";
import { Router, NavigationEnd } from '@angular/router';
import { LoaderService } from '../shared/loader/loader.service';
import { JsonPipe } from '@angular/common';
declare var dataLayer: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  loadComponents:boolean=false;
  isIframe:boolean;
  isUserAuthorized:boolean=false;
  showForbiddenMessage: any="appLoad";
  userName: string;
  userImage:string;
  isUserInactive: boolean=false;
  isFullScreenRoute: boolean=false;
  constructor(private ngZone: NgZone, private userService: UserService, private authService: AuthenticationService,private router: Router,private loader: LoaderService) {
    this.loadComponents=true;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isFullScreenRoute = event.urlAfterRedirects.includes('/api-docs');
      }
    });
   }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    let userRoles;
    userRoles=JSON.parse(localStorage.getItem('userRole'));

    if (!this.isIframe || (userRoles==null || (userRoles && userRoles.length==0))){
      this.authService.resetUser();
      if(this.userService.userEmail)
        this.getUserProfile(this.userService.userEmail);
      else
        this.getUserProfile(localStorage.getItem('userEmail'));
    }
  }
  getUserProfile(userName)
  {
    // this.loader.show();
    this.userService.getUserInfo("userProfile",userName,1).subscribe((value:any) => { 
      
      var userProfile = value.data;
      this.userName= value.data.userName;
      this.userImage=value.data.imageUrl;
      this.isUserInactive=userProfile.isDeleted
      if(this.isUserInactive)
      this.showForbiddenMessage="";
      else
      this.showForbiddenMessage="userAuthorized";
      this.authService.resetUser();
    // this.authService.setUser(null,0);
      let loggedInUserRoles = [];
      let allTenantsAssigned =[];
      let allAppsAssigned=[];
      if(userProfile.systemRole)
      {
        if(userProfile.systemRole.systemRoleType==0)
        loggedInUserRoles.push(Roles.SystemAdmin);
      else if(userProfile.systemRole.systemRoleType==1)
        loggedInUserRoles.push(Roles.SystemReader);
      }
       if(userProfile.tenantRoles && userProfile.tenantRoles.length>0)
      {
        userProfile.tenantRoles.forEach(element => {
          if(element.tenantRoleType==0){
          loggedInUserRoles.push(Roles.TenantOwner);
          allTenantsAssigned.push(element.tenantId);
          }
          if(element.tenantRoleType==1){
          loggedInUserRoles.push(Roles.TenantReader);
          allTenantsAssigned.push(element.tenantId);
          }
        });
      }
       if(userProfile.applicationRoles && userProfile.applicationRoles.length>0)
      {
        userProfile.applicationRoles.forEach(item => {
          item.associatedApplicationRoles.forEach(element => {
            if(element.applicationRoleType==0){
            loggedInUserRoles.push(Roles.AppOwner);
            allAppsAssigned.push(element.applicationId);
            }
            if(element.applicationRoleType==1){
            loggedInUserRoles.push(Roles.AppReader);
            allAppsAssigned.push(element.applicationId);
            }
            if(element.applicationRoleType==2){
            loggedInUserRoles.push(Roles.AppNotificationOwner);
            allAppsAssigned.push(element.applicationId);
            }
          });
        });
      }
      loggedInUserRoles = loggedInUserRoles.filter((el, i, a) => i === a.indexOf(el))
      localStorage.setItem('loggedInUserRoles',JSON.stringify(loggedInUserRoles));
      this.authService.setUser(userProfile,loggedInUserRoles);
      this.authService.setTenantIds(allTenantsAssigned);
      this.authService.setApplicationIds(allAppsAssigned);

     //omniture call
     if(dataLayer.pageInfo!==undefined){
      dataLayer.pageInfo.pageName='app load';
      dataLayer.pageInfo.userID=userProfile.userId;
      dataLayer.pageInfo.role=loggedInUserRoles;
      dataLayer.pageInfo.module="app load";
      }
      this.loader.hide();
      this.ngZone.run(() => { 
        if(!userProfile.isDeleted)
        this.isUserAuthorized = true; 
      });
     if(window.location.hash=='' || window.location.hash=='#/')
     this.router.navigate(["dashboard"]);
     //this.router.navigate(["dashboard"]);
    },err => {
      this.ngZone.run(() =>{
      this.showForbiddenMessage="";
      this.isUserAuthorized=false;
      });
      });
  }
}
